import { AddAPhoto } from "@mui/icons-material";
import { Button, IconButton, Tooltip, SxProps, Theme } from "@mui/material";
import React, { JSX } from "react";
import Resizer from "react-image-file-resizer";
import { useNotification } from "../notificationProvider";

interface ImageButtonProps {
  title?: string;
  setFoto: (uri: string) => void;
  callback?: () => void;
  isButton?: boolean;
  children?: React.ReactNode;
  sx?: SxProps<Theme>;
  [key: string]: any;
}

export default function ImageButton({
  title = "Adicionar imagem",
  setFoto = () => {},
  callback = () => {},
  isButton = false,
  children,
  ...buttonProps
}: ImageButtonProps): JSX.Element {
  const notify = useNotification();

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>): void => {
    const file = e.target.files?.[0];
    if (!file) return;

    Resizer.imageFileResizer(
      file,
      500,
      500,
      "JPEG",
      80,
      0,
      (value: string | File | Blob | ProgressEvent<FileReader>) => {
        if (typeof value === "string") {
          setFoto(value);
          if (callback) callback();
        } else {
          console.error("Unexpected value type:", value);
        }
      },
      "base64",
      500,
      500
    );

    const fileReader = new FileReader();
    fileReader.readAsDataURL(file);
    fileReader.onload = () => {
      // Você pode adicionar lógica adicional aqui, se necessário
    };
    fileReader.onerror = (error) => {
      console.error("Error:", error);
      notify("Error: " + error, "error");
    };
  };

  return (
    <Tooltip title={title}>
      {isButton ? (
        <Button {...buttonProps} component={(props) => <label {...props} />}>
          {children}
          <input
            hidden
            accept=".png, .jpg, .jpeg"
            type="file"
            onChange={handleChange}
          />
        </Button>
      ) : (
        <IconButton {...buttonProps} component="label">
          {children}
          <input
            hidden
            accept=".png, .jpg, .jpeg"
            type="file"
            onChange={handleChange}
          />
          <AddAPhoto fontSize="small" />
        </IconButton>
      )}
    </Tooltip>
  );
}